export default function(startDateTimeString, endDateTimeString) {
  let startDateTime = new Date(startDateTimeString);
  let endDateTime = new Date(endDateTimeString);
  let diffDate;
  if (startDateTime > endDateTime) {
    diffDate = new Date(startDateTime - endDateTime);
  } else {
    diffDate = new Date(endDateTime - startDateTime);
  }
  let result = "";
  if (diffDate.getMinutes() > 0) {
    result = diffDate.getMinutes() + "m " + result;
  }
  if (diffDate.getHours() > 0) {
    result = diffDate.getHours() - 1 + "h " + result;
  }
  if (diffDate.getDate() > 1) {
    result = diffDate.getDate() - 1 + "d " + result;
  }
  return result;
}
